// by szq on 2017-09-08
// wiki: http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959

export const USER_GET_WECHAT_CODE = 'USER_GET_WECHAT_CODE'
// 获取用户信息
export const USER_GET_INFO = 'USER_GET_INFO'
export const USER_GET_INFO_BY_CODE = 'USER_GET_INFO_BY_CODE'
export const USER_SET_INFO = 'USER_SET_INFO'

// 发送找回密码短信
export const USER_SEND_PASSWORD_MSG = 'USER_SEND_PASSWORD_MSG'
// 验证找回密码
export const USER_VERIFY_PASSWORD = 'USER_VERIFY_PASSWORD'
// 重置找回密码
export const USER_RESET_PASSWORD = 'USER_RESET_PASSWORD'

// 匹配学生档案信息
export const USER_MATCH_STUDENTS = 'USER_MATCH_STUDENTS'
// 绑定学生档案
export const USER_BIND_STUDENT = 'USER_BIND_STUDENT'
// 获取captcha code
export const USER_GET_CAPTCHA = 'USER_GET_CAPTCHA'
// 上传微信埋点
export const USER_POST_TRACK_POINT = 'USER_POST_TRACK_POINT'
// 获取用户学校配置
export const USER_GET_SCHOOL_CONFIG = 'USER_GET_SCHOOL_CONFIG'
export const USER_SET_SCHOOL_CONFIG = 'USER_SET_SCHOOL_CONFIG'
// 删除支付
export const USER_DEL_PAYMENT = 'USER_DEL_PAYMENT'

// 虚拟学生绑定真实学生
export const USER_BIND_REAL_STUDENT = 'USER_BIND_REAL_STUDENT'
export const USER_ENROLL = 'USER_ENROLL'



// WEBPACK FOOTER //
// ./src/views/ReportApp/store/types/types_user.js